import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../../components/Header';
import Activities from '../../../components/Activities/Activity';
import SpecificInstructionDetailsPage from './SpecificInstructionDetailsPage';

const SpecificInstructionDetails = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <Header title={'Specific Instruction Details'} showBackButton={true} />

      <div className="grid grid-cols-12">
        {/* Main content */}
        <div className="col-span-8 px-6 py-6">
          <SpecificInstructionDetailsPage />
        </div>

        {/* Vertical Divider */}
        <div className="col-span-1 flex justify-end">
          <div className="w-px bg-gray-200 h-full translate-x-4" />
        </div>

        {/* Activities Sidebar */}
        <div className="col-span-3 py-6 pr-6">
          <Activities moduleName="specific_instructions" moduleItemId={Number(id)} />
        </div>
      </div>
    </div>
  );
};

export default SpecificInstructionDetails;
